import { ref } from "vue";

interface IAccount {
  account: string;
  name: string;
  code: any;
  applications: Array<any>;
}

const account = () => {
  const account = ref<IAccount>({
    account: "",
    name: "",
    code: {},
    applications: [],
  });

  account.value = localStorage.getItem("ACCOUNT")
    ? JSON.parse(localStorage.getItem("ACCOUNT") || "")
    : "";

  return {
    account,
  };
};

export default account;
